export { default as router } from './router';
export { default as store } from './store';
export { i18n } from './i18n';
export { default as App } from './App';